var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.105 4.22999L4.70997 12.555C3.53997 13.485 2.78997 15.45 3.04497 16.92L5.03997 28.86C5.39997 30.99 7.43997 32.715 9.59997 32.715H26.4C28.545 32.715 30.6 30.975 30.96 28.86L32.955 16.92C33.195 15.45 32.445 13.485 31.29 12.555L20.895 4.24499C19.29 2.95499 16.695 2.95499 15.105 4.22999Z",
    stroke: "#EFF2FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.25C18.9946 23.25 19.9484 22.8549 20.6517 22.1517C21.3549 21.4484 21.75 20.4946 21.75 19.5C21.75 18.5054 21.3549 17.5516 20.6517 16.8483C19.9484 16.1451 18.9946 15.75 18 15.75C17.0054 15.75 16.0516 16.1451 15.3483 16.8483C14.6451 17.5516 14.25 18.5054 14.25 19.5C14.25 20.4946 14.6451 21.4484 15.3483 22.1517C16.0516 22.8549 17.0054 23.25 18 23.25Z",
    stroke: "#EFF2FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.72b9fbae52942ccddf8fca4425b40e52.svg";
export { ForwardRef as ReactComponent };